/**
 * Musical keys (2026-09-29). A key is { tonic, mode } with the tonic spelled
 * from NAMES (the same spelling tools/track-worker/detect_key.py and the
 * trackKeys rule use). Pure: no Firestore.
 */
export const NAMES = ['C', 'C#', 'D', 'Eb', 'E', 'F', 'F#', 'G', 'Ab', 'A', 'Bb', 'B'];
export const MODES = ['major', 'minor'];

export const isKey = (k) => Boolean(k && NAMES.includes(k.tonic) && MODES.includes(k.mode));
export const keyName = (k) => (isKey(k) ? `${k.tonic} ${k.mode}` : '');

/** The key `semitones` away (a saved key, the live key change). */
export const transposeKey = (k, semitones = 0) => {
	if (!isKey(k)) return null;
	const n = Math.round(Number(semitones) || 0);
	const i = (((NAMES.indexOf(k.tonic) + n) % 12) + 12) % 12;
	return { tonic: NAMES[i], mode: k.mode };
};

/**
 * What the key line says, from a trackKeys doc: the teacher's correction
 * wins over the estimate. { key, source: 'teacher'|'detected'|null, alt,
 * unsure } where `unsure` means the estimate barely beat its runner-up.
 */
export const UNSURE_BELOW = 0.1;
export const keyFromDoc = (doc) => {
	if (doc && isKey(doc.confirmed)) return { key: doc.confirmed, source: 'teacher', alt: null, unsure: false };
	const d = doc && doc.detected;
	if (isKey(d)) {
		// The five-profile vote says so itself (`unsure`: under 3 of 5 agree,
		// 2026-09-29); the older chroma estimate is judged by its margin.
		const conf = Number(d.confidence);
		const unsure = typeof d.unsure === 'boolean' ? d.unsure : Number.isFinite(conf) && conf < UNSURE_BELOW;
		return { key: { tonic: d.tonic, mode: d.mode }, source: 'detected', alt: isKey(d.alt) ? d.alt : null, unsure };
	}
	return { key: null, source: null, alt: null, unsure: false };
};
